import { useState } from "react";
import "./OnboardingChecklist.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { MdAdd, MdClose, MdMinimize } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import VideoPlayer from "../videoPlayer/VideoPlayer";
import CircularButton from "../ui/CustomButton";
import { useSelector } from "react-redux";


const OnboardingChecklist = ({ handleDismiss }) => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const location = useLocation();
  const [openIndex, setOpenIndex] = useState(null);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [videoTitle, setVideoTitle] = useState(null);
  const [video, setVideo] = useState(null);
  const tasks = [
    {
      title: "Create your first client",
      description: "Add a new client or upload your client list to start managing relationships in one place.",
      link: "clients",
      tutorial: "creatingClients"
    },
    {
      title: "Add a risk note",
      description: "Record and organize key risk details for each client to ensure compliance and accuracy.",
      link: "docs/risknote",
      tutorial: "creatingRiskNotes"
    },
    {
      title: "Explore pre-loaded products",
      description: "Save time by browsing and selecting from pre-loaded insurance products ready to use.",
      link: "uwproducts",
      tutorial: "creatingClients"
    },
    {
      title: "Create your first opportunity",
      description: "Turn prospects into deals by creating your first opportunity and tracking follow-ups.",
      link: "bd/oppo",
      tutorial: "creatingClients"
    },
    {
      title: "Request quotes from carriers",
      description: "Easily generate quote requests and send them directly to your preferred carriers.",
      link: "bd/quotereq",
      tutorial: "creatingClients"
    },
    {
      title: "Set default rates",
      description: "Configure your carriers’ default commission and premium rates for faster quoting.",
      link: "rates",
      tutorial: "creatingClients"
    }
  ];

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleNavigate = (path, e) => {
    e.stopPropagation();
    navigate(`/${path}`, {
      state: {
        showBack: "Y",
        menuDocid: "1111",
        favMenu: "Y"
      },
    });
  };

  return (
    <div className="onboarding-checklist">
      <div className="checklist-navbar">
        <span className="sub-title"> {t('gettingStarted').toUpperCase()} </span>
        {location.pathname !== "/onboarding" && <span className="sub-title dismiss" onClick={handleDismiss}><MdClose size={15} /> {t('dismiss')}</span>}
      </div>
      <div className="checklist-wrapper">
        {tasks.map((task, index) => (
          <div key={index} className="checklist-card">
            <div className="checklist-header" onClick={() => toggle(index)}>
              <span className="main-title">{task.title}</span>
              <span className="icon">{openIndex === index ? <MdMinimize size={20} /> : <MdAdd size={20} />}</span>
            </div>

            {openIndex === index && (
              <div className="checklist-body">
                <p>{task.description}</p>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                  <button
                    className="link-button"
                    onClick={(e) => handleNavigate(task.link, e)}
                  >
                    Go to task →
                  </button>
                  {task?.tutorial &&
                    <button
                      className="link-button"
                      onClick={(e) => {
                        try {
                          setVideoTitle(task?.title);
                          setVideo(task?.tutorial);
                          setIsOverlayOpen(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      Watch
                    </button>}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {isOverlayOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="main-title">{videoTitle}</span>
              <CircularButton currentTheme={currentTheme} onClick={() => setIsOverlayOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <VideoPlayer videoUrl={video} />
            </div>
            <div className="overlay-actions">
            </div>
          </div>
        </motion.div>
      )}
    </div>
  )
}

export default OnboardingChecklist;